import { Component, TemplateRef, ViewChild } from '@angular/core';

import { CsqLogoComponent } from './csq-logo.component';

@Component({
  selector: 'app-csq-logo-template',
  imports: [CsqLogoComponent],
  template: `
    <ng-template #csqLogoTemplate>
      <app-csq-logo></app-csq-logo>
    </ng-template>
  `,
})
export class CsqLogoTemplateComponent {
  @ViewChild('csqLogoTemplate', { static: true }) csqLogoTemplate!: TemplateRef<any>;
}
